import { lazy } from 'react';

export const LazyDropboxLoginVerificationPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--dropbox-login-verification-page" */ './dropbox-login-verification-page'
    ),
);
